import keycloakAuth from '../services/keycloakAuth';
import { isWorkspaceGuest } from '../services/scaleWorkspace';

/**
 * Middleware to check if user has required role to access the dashboard
 * Redirects to SSO manager if user doesn't have app_groovecm role
 */
export default async (to, from, next) => {
  // Check if user is authenticated with Keycloak
  if (!keycloakAuth.isAuthenticated()) {
    // Let the auth middleware handle unauthenticated users
    return next();
  }

  // A Scale workspace guest opens the owner's dashboard through the grant the
  // owner gave them; gd-apis re-authorizes every request with the hub.
  if (isWorkspaceGuest()) {
    return next();
  }

  // Get user roles from token
  const roles = keycloakAuth.getRoles();
  const requiredRole = 'app_groovecm';

  // Check if user has the required role
  const hasAccess = roles.includes(requiredRole);

  if (!hasAccess) {
    console.warn(`Access denied: User does not have ${requiredRole} role`);

    // Get SSO manager URL from environment or default
    const ssoUrl = window.gdEnv?.VUE_APP_SSO_MANAGER_URL || 'https://app.scaleplus.gg';

    // Redirect to SSO manager with error message
    window.location.href = `${ssoUrl}/dashboard?error=access_denied&app=groovecm&message=You do not have access to GrooveCM Dashboard`;
    return;
  }

  // User has access, continue
  next();
};
